import { useMutation, useQueryClient } from "@tanstack/react-query";
import { userInfoKeys } from "Auth/Api/Queries/useUserInfoQuery";
import { type SetRoleRequest, putAuthRole } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const usePutAuthRoleMutation = ({ onSuccess, onError }: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails((data: SetRoleRequest) =>
      putAuthRole(data),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: userInfoKeys.all });
      onSuccess?.();
    },
    onError,
  });
};
